// Constant value for the tab parameter in URLs
export const CURRENT_TAB_PARAM_NAME = "tab";
// Constant value for the data process alias used in routing and navigation
export const DATA_PROCESS_ALIAS = "data-process";
// Constant value for the data process list, used to provide a list of jobs
export const DATA_PROCESS_LIST: string = "dataProcessList";
// Constant value for the data process overview alias, used in routing and navigation
export const TAB_OVERVIEW_ALIAS = "overview";
export const TAB_CONFIGURATION_ALIAS = "configuration";
